import {
  AUTHENTICATING_TEAMS_REQUEST, AUTHENTICATING_TEAMS_SUCCEDDED, AUTHENTICATING_TEAMS_FAILED,
  UPDATING_TEAMS_RECORDING_TOGGLE_REQUEST, UPDATING_TEAMS_RECORDING_TOGGLE_SUCCEEDED, UPDATING_TEAMS_RECORDING_TOGGLE_FAILED,
} from '../actionTypes.jsx';

import { activatingIntegrationSuccedded } from '../integrations';
import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const INTEGRATION_BASE_URL = `${apiUrl}/api/2.0/integrations`;

export function beginTeamsAuthentication() {
  return authenticatingAccount();
}

export function authenticateAccount(code, integrationType) {
return function (dispatch) {
  dispatch(authenticatingAccount());

  const data = {
      code: code
  }

  let url = buildUrl(INTEGRATION_BASE_URL, {
    path: `${integrationType}`,
  });

  return axios({
    method: 'POST',
    url: url,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: data
  })
  .then((response) => {
      dispatch(authenticatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
  })
  .catch(error =>
      dispatch(authenticatingAccountFailed(error.errors))
  )
}
}

function authenticatingAccount() {
  return {
      type: AUTHENTICATING_TEAMS_REQUEST,
      payload: {}
  }
}

function authenticatingAccountSuccedded(json) {
  return {
      type: AUTHENTICATING_TEAMS_SUCCEDDED,
      payload: json
  }
}

function authenticatingAccountFailed(error) {
  return {
      type: AUTHENTICATING_TEAMS_FAILED,
      payload: error
  }
}

export function updateTeamsRecordingToggle(enabled) {
  return function (dispatch) {
    dispatch(updatingTeamsRecordingToggle());

    const url = buildUrl(INTEGRATION_BASE_URL, {
      path: `/teams/recording-access`,
    });

    return axios({
      method: "PUT",
      url: url,
      data: enabled
    })
      .then((response) => {
        dispatch(updatingTeamsRecordingToggleSucceeded(response));
      })
      .catch((error) => {
        dispatch(updatingTeamsRecordingToggleFailed(error));
      });
  };
}

function updatingTeamsRecordingToggle() {
  return { type: UPDATING_TEAMS_RECORDING_TOGGLE_REQUEST };
}

function updatingTeamsRecordingToggleSucceeded(response) {
  return {
    type: UPDATING_TEAMS_RECORDING_TOGGLE_SUCCEEDED,
    payload: response,
  };
}

function updatingTeamsRecordingToggleFailed(error) {
  return {
    type: UPDATING_TEAMS_RECORDING_TOGGLE_FAILED,
    payload: error,
  };
}
